/*eslint react/no-deprecated: 0*/

import React from 'react';
import moment from 'moment';
import { Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';
import { change } from 'redux-form';

import { Field, reduxForm } from 'redux-form/immutable';
import * as validations from 'modules/forms/validations';
import { FORM_PRECIOS } from 'modules/forms/formConstants';
import { TextFieldF, DatePickerF, CheckBoxFieldF } from 'modules/forms/component';

import * as preciosActions from 'modules/precios/action';
import * as generalActions from 'modules/general/action';
import { CancelarButtonC, SeleccionadorC } from 'modules/general/component';

const DateTimeFormat = global.Intl.DateTimeFormat;
moment.locale('es');

class Add extends React.Component {
  componentDidMount() {
    const {
      dispatch,
      params: { nombrePrecio },
    } = this.props;
    if (!nombrePrecio) dispatch(generalActions.dashboard_changeTitle('AGREGAR PRECIO'));
    else {
      dispatch(generalActions.dashboard_changeTitle('MODIFICAR PRECIO'));
      dispatch(change('FORM_PRECIOS', 'nombre', nombrePrecio));
    }
  }
  componentWillUnmount = () => {
    this.props.dispatch(preciosActions.clear('confirmacionRequerida'));
  };
  submitForm = (data) => {
    data = data.toJS();
    data.precio = Number(data.precio);
    this.props.dispatch(preciosActions.set(data));
  };
  render = () => {
    const { confirmacionRequerida } = this.props;

    return (
      <div>
        <Row className="rowContainer">
          <Col md={{ size: 4, offset: 4 }}>
            <MaterialUI.Paper zDepth={2} className="container">
              <form onSubmit={this.props.handleSubmit(this.submitForm)}>
                <Row>
                  <Col md="12">
                    <Field
                      name={'nombre'}
                      component={TextFieldF}
                      inputProps={{
                        fullWidth: true,
                        hintText: 'Nombre',
                        floatingLabelText: 'Identificación del precio',
                      }}
                      validate={validations.required}
                    />
                  </Col>
                  <Col md="12">
                    <Field
                      name="precio"
                      component={TextFieldF}
                      inputProps={{
                        fullWidth: true,
                        hintText: 'Precio',
                        floatingLabelText: 'Precio',
                      }}
                      validate={validations.number}
                    />
                  </Col>
                  <Col md="12">
                    <Field
                      name="fechaInicio"
                      component={DatePickerF}
                      className="fullWidthComponent minHeight55"
                      inputProps={{
                        autoOk: true,
                        format: '24hr',
                        fullWidth: true,
                        hintText: 'Fecha de inicio',
                        floatingLabelText: 'Fecha inicio',
                      }}
                      format={(value) => (typeof value == 'string' ? null : value)}
                      validate={validations.required}
                    />
                  </Col>
                  {confirmacionRequerida && (
                    <Col md="12" style={{ paddingTop: 20 }}>
                      <Field
                        name="confirmacion"
                        component={CheckBoxFieldF}
                        inputProps={{
                          label: 'Confirmar cambio de precio',
                        }}
                      />
                      <MaterialUI.Divider />
                    </Col>
                  )}
                  <Col md="12">
                    <MaterialUI.RaisedButton type="submit" primary={true} label="GUARDAR" className="fullWidthComponent noPadding m-tb-20" />
                  </Col>
                </Row>
              </form>
            </MaterialUI.Paper>
          </Col>
        </Row>
      </div>
    );
  };
}

Add = reduxForm({
  form: FORM_PRECIOS,
  enableReinitialize: true,
})(Add);

Add = connect((store) => ({
  confirmacionRequerida: store.getIn(['precios', 'confirmacionRequerida']),
}))(Add);

export default Add;



// WEBPACK FOOTER //
// src/modules/precios/components/add.js